import React from "react";
import Taats from "../../doors/taats";
import { ConfigurationProps } from "../../Door";

interface SingleTaatsProps extends ConfigurationProps {}

const SingleTaats: React.FC<SingleTaatsProps> = ({
  materials,
  position,
  scale,
  doorSettings,
}: SingleTaatsProps) => {
  return (
    <group scale={scale}>
      <Taats
        materials={materials}
        position={position}
        frameSettings={doorSettings?.main?.frameSettings}
      />
    </group>
  );
};

export default SingleTaats;
